module.exports = __webpack_public_path__ + "assets/cac5c4732f7877fa4d6a9bf326cb302a.png";